import React from 'react';
import styled from 'styled-components';
import { LinkButton as BaseLinkButton } from '../common/Button';
import { useConsent } from '../../context/ConsentContext';

const LinkButton = styled(BaseLinkButton)`
    color: inherit;
    font: inherit;
    text-decoration: underline;
    opacity: 0.85;

    &:hover:not(:disabled) {
        opacity: 1;
    }
`;

export default function CookieSettingsLink({ label = 'Cookie settings', className }) {
    const { openPreferences } = useConsent();
    return (
        <LinkButton type="button" onClick={openPreferences} className={className}>
            {label}
        </LinkButton>
    );
}
